import api from './client'

export interface Portion {
  id: number
  name: string
  full_name: string | null
  display_order: number
}

export interface Domain {
  id: number
  portion_id: number
  name: string
  description: string | null
  weight_percent: number
  display_order: number
}

export interface Mastery {
  id: number
  domain_id: number
  name: string
  description: string | null
  video_url: string | null
  course_file: string | null
  display_order: number
}

export interface Course {
  mastery_id: number
  domain_id: number
  portion_id: number
  name: string
  description: string | null
  course_file: string
  domain_name: string
  portion_name: string
  display_order: number
  domain_display_order: number
  portion_display_order: number
}

export const contentApi = {
  getPortions: () => api.get<Portion[]>('/portions'),
  getDomains: (portionId: number) => api.get<Domain[]>(`/portions/${portionId}/domains`),
  getMasteries: (domainId: number) => api.get<Mastery[]>(`/domains/${domainId}/masteries`),
  getCourses: () => api.get<Course[]>('/courses'),
  getCourse: (courseFile: string) => api.get<Course>(`/courses/${courseFile}`),
}
